import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default function Gallery() {
  return {
    init: () => {
      const galleries = document.querySelectorAll('[data-w-gallery]');

      galleries.forEach((gallery) => {
        const parent = gallery.parentElement;

        gsap.set(gallery, {
          '--offset': -1,
        });
        gsap.to(gallery, {
          '--offset': 1,
          duration: 2,
          // ease: 'power4.inOut',
          scrollTrigger: {
            trigger: parent,
            start: 'top bottom',
            end: 'bottom center',
            scrub: 1,
            // markers: true,
          },
        });
      });
    },
  };
}
